<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Order</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">Order</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="main-content-label mb-1">Order</h6>
              <div>
                <p class="font-weight-bold">{{formData.date}}</p>
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Name:</p>
                <p>{{formData.name}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Email:</p>
                <p>{{formData.email}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Phone:</p>
                <p>{{formData.phone}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Price:</p>
                <p>{{formData.price}} {{formData.currency_code}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Day:</p>
                <p>{{formData.day}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Recovery Name:</p>
                <p>{{formData.recovery_name}}</p>
              </div>
              <div class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">Diagnostic Name:</p>
                <p>{{formData.diagnostic_name}}</p>
              </div>
              <div v-for="(item, index) in formData.order_details" :key="index" class="d-flex align-items-center mb-3">
                <p class="mr-5 font-weight-bold">{{item.product_type.title[$i18n.locale]}}</p>
                <p>{{item.title[$i18n.locale]}}</p>
                <p class="ml-3 font-weight-bold">x</p>
                <p class="ml-3">{{item.pivot.count}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'order',
  data () {
    return {
      formData: {}
    }
  },
  created () {
    this.getOrder(this.$route.params.id).then(res => {
      console.log(res.data)
      this.formData = { ...res.data }
    })
  },
  methods: {
    ...mapActions({
      getOrder: 'orders/getOrder'
    })
  }
}
</script>
